// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Tab strip ─────────────────────────────────────────────────────────── */

.md3US8PwqSYOhlnvQocc {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 10px 16px;
    background: var(--curio-card-bg);
    border-bottom: 1px solid var(--curio-border);
    font-family: var(--curio-font-family);
}

.Jf2ahtz7VhSEIF46n1Wd {
    position: relative;
    background: none;
    border: none;
    padding: 6px 14px;
    font: inherit;
    font-size: var(--curio-font-size-md);
    font-weight: 500;
    color: var(--curio-text-secondary);
    cursor: pointer;
    border-radius: var(--curio-radius-sm);
    display: inline-flex;
    align-items: center;
    gap: 6px;
}

.Jf2ahtz7VhSEIF46n1Wd:hover {
    color: var(--curio-text-primary);
    background: rgba(30, 31, 35, 0.04);
}

.GCphMd3mvSTKwCsx82SI,
.GCphMd3mvSTKwCsx82SI:hover {
    background: var(--curio-top-bar-bg);
    color: var(--curio-text-on-dark);
}

.oJZImuAZdM97pz3VhAbl {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 18px;
    height: 16px;
    padding: 0 6px;
    border-radius: var(--curio-radius-pill);
    font-size: 10px;
    font-weight: 700;
    line-height: 1;
}

.t32D_XmffKgj8v2Y_ZlX {
    background: rgba(30, 31, 35, 0.1);
    color: var(--curio-text-primary);
}

.GCphMd3mvSTKwCsx82SI .t32D_XmffKgj8v2Y_ZlX {
    background: rgba(255, 255, 255, 0.18);
    color: var(--curio-text-on-dark);
}

.Xm9KvDfk4GqXk7hdwlCU {
    background: var(--curio-role-update-bg);
    color: var(--curio-role-update-fg);
}

.R1koP_pctSxH2mWBPtGi {
    color: var(--curio-text-muted);
}
`, "",{"version":3,"sources":["webpack://./src/components/packages/publishing/DrawerTabs.module.css"],"names":[],"mappings":"AAAA,6EAA6E;;AAE7E;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,gCAAgC;IAChC,4CAA4C;IAC5C,qCAAqC;AACzC;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,aAAa;IACb,oCAAoC;IACpC,gBAAgB;IAChB,kCAAkC;IAClC,eAAe;IACf,qCAAqC;IACrC,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,gCAAgC;IAChC,kCAAkC;AACtC;;AAEA;;IAEI,mCAAmC;IACnC,gCAAgC;AACpC;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,cAAc;IACd,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,iCAAiC;IACjC,gCAAgC;AACpC;;AAEA;IACI,qCAAqC;IACrC,gCAAgC;AACpC;;AAEA;IACI,uCAAuC;IACvC,kCAAkC;AACtC;;AAEA;IACI,8BAA8B;AAClC","sourcesContent":["/* ── Tab strip ─────────────────────────────────────────────────────────── */\n\n.tabs {\n    flex-shrink: 0;\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    padding: 10px 16px;\n    background: var(--curio-card-bg);\n    border-bottom: 1px solid var(--curio-border);\n    font-family: var(--curio-font-family);\n}\n\n.tab {\n    position: relative;\n    background: none;\n    border: none;\n    padding: 6px 14px;\n    font: inherit;\n    font-size: var(--curio-font-size-md);\n    font-weight: 500;\n    color: var(--curio-text-secondary);\n    cursor: pointer;\n    border-radius: var(--curio-radius-sm);\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n}\n\n.tab:hover {\n    color: var(--curio-text-primary);\n    background: rgba(30, 31, 35, 0.04);\n}\n\n.tabActive,\n.tabActive:hover {\n    background: var(--curio-top-bar-bg);\n    color: var(--curio-text-on-dark);\n}\n\n.tabBadge {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 18px;\n    height: 16px;\n    padding: 0 6px;\n    border-radius: var(--curio-radius-pill);\n    font-size: 10px;\n    font-weight: 700;\n    line-height: 1;\n}\n\n.tabBadgeDark {\n    background: rgba(30, 31, 35, 0.1);\n    color: var(--curio-text-primary);\n}\n\n.tabActive .tabBadgeDark {\n    background: rgba(255, 255, 255, 0.18);\n    color: var(--curio-text-on-dark);\n}\n\n.tabBadgeAccent {\n    background: var(--curio-role-update-bg);\n    color: var(--curio-role-update-fg);\n}\n\n.tabMuted {\n    color: var(--curio-text-muted);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tabs": `md3US8PwqSYOhlnvQocc`,
	"tab": `Jf2ahtz7VhSEIF46n1Wd`,
	"tabActive": `GCphMd3mvSTKwCsx82SI`,
	"tabBadge": `oJZImuAZdM97pz3VhAbl`,
	"tabBadgeDark": `t32D_XmffKgj8v2Y_ZlX`,
	"tabBadgeAccent": `Xm9KvDfk4GqXk7hdwlCU`,
	"tabMuted": `R1koP_pctSxH2mWBPtGi`
};
export default ___CSS_LOADER_EXPORT___;
